import { Component } from '@felicity/vision';
import { Breadcrumb } from '@syncfusion/ej2-navigations';
import {
  AssessmentManager, AssessorManager, ToolSelector,
  Report, ScoreChart, HazardRiskChart, HazardWeightChart
} from '@felicity/multi-criteria-analysis';
import AssessorSelector from '../ui/AssessorSelector.mjs';

/**
 * Assessments screen
 */
export default class Assessments extends Component {
  /**
   * Project identifier of the assessments
   * @type {string}
   * @format uuid
   */
  projectId;

  /**
   * Whether assessor management features should be enabled
   * @type {boolean}
   * @default false
   */
  assessorManagement = false;

  /**
   * Provides access to the assessment manager
   * @type {AssessmentManager}
   */
  get assessmentManager() {
    return this.#manager;
  }

  /** @type {AssessmentManager} */
  #manager;

  constructor() {
    super();

    this.#manager = new AssessmentManager();
  }

  _prepare() {
    super._prepare();
    this.classList.add('screen');

    const breadcrumbItems = this.querySelector('script[type="application/json"][name="breadcrumb"]');
    if (breadcrumbItems) {
      // eslint-disable-next-line no-new
      new Breadcrumb({
        items: JSON.parse(breadcrumbItems.textContent).items
      }, this.appendChild(document.createElement('nav')));
    }

    const uri = '/api/MCA/Assessment';
    this.assessmentManager.projectId = this.projectId;
    this.assessmentManager.crudUri = uri;
    this.assessmentManager.urlTemplateOf('clone', `${uri}/\${assessmentId}/Clone`);
    this.assessmentManager.urlTemplateOf('export', `${uri}/\${assessmentId}/Export`);
    this.assessmentManager.urlTemplateOf('statistics', `${uri}/\${assessmentId}/Statistics`);
    if (this.assessorManagement) {
      this.assessmentManager.assessorManagement = true;
      this.assessmentManager.assessorSelectorClass = AssessorSelector;
    }

    this.appendChild(this.assessmentManager);
    this.assessmentManager.grid.height = '100%';
    this.assessmentManager.grid.width = '100%';
  }
}

ScoreChart.register('score-chart');
HazardRiskChart.register('hazard-risk-chart');
HazardWeightChart.register('hazard-weight-chart');
Report.register('report');
ToolSelector.register('tool-selector');
AssessorSelector.register('assessor-selector');
AssessmentManager.register('assessment-manager');
AssessorManager.register('assessor-manager');
